(() => {
  const initialize = (root) => {
    if (root.dataset.contactReady) return;
    root.dataset.contactReady = 'true';
    const form = root.querySelector('form');
    const topics = root.querySelectorAll('[data-contact-topic]');
    const details = root.querySelectorAll('[data-contact-details]');
    const update = () => {
      const chosen = root.querySelector('[data-contact-topic]:checked');
      details.forEach((group) => {
        const active = chosen?.dataset.contactTopic === group.dataset.contactDetails;
        group.hidden = !active;
        group.querySelectorAll('input').forEach((input) => { input.disabled = !active; });
      });
    };
    topics.forEach((input) => input.addEventListener('change', update));
    form?.addEventListener('reset', () => requestAnimationFrame(update));
    window.addEventListener('pageshow', update);
    update();
  };
  const scan = () => document.querySelectorAll('[data-ricordo-contact]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
